var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #f4f4f6;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 12.78px;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 0 0 0 19.17;\n      }\n\n      .cls-3 {\n        fill: #f4f4f6;\n      }\n\n      .cls-4 {\n        fill: #333;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1000,
    height: 600
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.06,
    y: 101.8,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 141.16,
    y: 174.32,
    width: 18.44,
    height: 6.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m159.65,135.11l-7.88-12.47h-.21c-.38,0-.69.31-.69.69v20.76c0,.63.39,1.18.96,1.43,1.54.68,2.62,2.22,2.63,4.02,0,2.32-1.85,4.29-4.16,4.41-2.54.14-4.65-1.89-4.65-4.4,0-1.8,1.08-3.35,2.63-4.03.58-.25.96-.81.96-1.44v-20.75c0-.38-.31-.69-.69-.69h-.21l-7.88,12.47-6.99,10.77c-1.36,2.1-1.61,4.73-.66,7.04l8.24,20.11h18.01l8.24-20.11c.95-2.31.7-4.94-.66-7.04l-6.99-10.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m160.38,175.04h-20.05c-.25,0-.46-.2-.46-.46h0c0-.25.2-.46.46-.46h20.05c.25,0,.46.2.46.46h0c0,.25-.2.46-.46.46Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m130.87,284.26h7.9v28.51c0,3.12-.73,5.87-2.21,8.25s-3.53,4.22-6.19,5.55c-2.66,1.33-5.76,1.99-9.31,1.99s-6.68-.66-9.33-1.99c-2.66-1.33-4.72-3.18-6.18-5.55-1.46-2.37-2.19-5.12-2.19-8.25v-28.51h7.9v27.85c0,1.82.4,3.44,1.2,4.86.8,1.42,1.94,2.53,3.4,3.33,1.46.8,3.2,1.2,5.2,1.2s3.74-.4,5.21-1.2c1.47-.8,2.6-1.91,3.4-3.33.8-1.42,1.19-3.04,1.19-4.86v-27.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m154.75,308.72v19.18h-7.71v-32.73h7.37v5.56h.38c.75-1.83,1.96-3.29,3.61-4.37,1.65-1.08,3.7-1.62,6.15-1.62,2.26,0,4.23.48,5.91,1.45,1.68.97,2.99,2.36,3.92,4.2.93,1.83,1.39,4.06,1.37,6.67v20.84h-7.71v-19.64c0-2.19-.56-3.9-1.69-5.14-1.13-1.24-2.69-1.85-4.68-1.85-1.35,0-2.55.29-3.59.88-1.04.59-1.86,1.44-2.45,2.55-.59,1.11-.88,2.45-.88,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m187.5,290.52c-1.22,0-2.27-.41-3.15-1.23-.88-.82-1.32-1.8-1.32-2.95s.44-2.16,1.32-2.97c.88-.82,1.93-1.23,3.15-1.23s2.29.41,3.16,1.23c.87.82,1.31,1.81,1.31,2.97s-.44,2.13-1.31,2.95c-.87.82-1.93,1.23-3.16,1.23Zm-3.88,37.37v-32.73h7.71v32.73h-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m221.1,340.17v-17.43h-.32c-.4.8-.97,1.64-1.73,2.52-.75.89-1.75,1.64-2.98,2.27-1.24.62-2.79.94-4.67.94-2.57,0-4.87-.66-6.9-1.98-2.03-1.32-3.64-3.24-4.82-5.75-1.18-2.51-1.77-5.57-1.77-9.16s.6-6.71,1.8-9.21c1.2-2.51,2.82-4.4,4.87-5.69,2.05-1.29,4.33-1.93,6.84-1.93,1.92,0,3.49.32,4.73.97s2.22,1.42,2.94,2.32c.72.9,1.29,1.75,1.68,2.55h.47v-5.41h7.59v45h-7.73Zm-7.54-18.03c1.63,0,3.03-.44,4.18-1.33,1.15-.89,2.02-2.13,2.62-3.72.6-1.59.9-3.44.9-5.56s-.29-3.96-.88-5.52-1.46-2.78-2.6-3.64c-1.14-.87-2.55-1.3-4.21-1.3s-3.15.45-4.3,1.34c-1.15.9-2.02,2.13-2.6,3.71-.58,1.58-.87,3.38-.87,5.41s.29,3.87.88,5.46c.59,1.6,1.46,2.86,2.62,3.77s2.58,1.37,4.27,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m257.6,314.13v-18.96h7.71v32.73h-7.48v-5.82h-.34c-.74,1.83-1.95,3.33-3.63,4.5-1.68,1.17-3.75,1.75-6.21,1.75-2.15,0-4.04-.48-5.68-1.44-1.64-.96-2.92-2.36-3.85-4.2-.92-1.84-1.39-4.07-1.39-6.68v-20.84h7.71v19.65c0,2.07.57,3.72,1.7,4.94,1.14,1.22,2.63,1.83,4.47,1.83,1.14,0,2.24-.28,3.3-.83s1.94-1.38,2.63-2.48,1.03-2.48,1.03-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m287.73,328.54c-3.28,0-6.11-.69-8.49-2.06-2.38-1.37-4.21-3.32-5.49-5.84-1.28-2.52-1.92-5.49-1.92-8.92s.64-6.32,1.93-8.87,3.09-4.54,5.4-5.97c2.32-1.43,5.04-2.14,8.16-2.14,2.02,0,3.92.32,5.72.97s3.39,1.64,4.77,2.99,2.48,3.07,3.27,5.15c.8,2.08,1.19,4.56,1.19,7.43v2.37h-26.83v-5.2h19.43c-.01-1.48-.33-2.79-.96-3.95-.62-1.16-1.5-2.07-2.61-2.74-1.12-.67-2.41-1-3.89-1-1.58,0-2.96.38-4.15,1.14s-2.12,1.75-2.78,2.98c-.66,1.23-1,2.58-1.01,4.04v4.54c0,1.9.35,3.53,1.04,4.89.7,1.36,1.67,2.39,2.92,3.11,1.25.72,2.71,1.08,4.39,1.08,1.12,0,2.14-.16,3.05-.48s1.7-.79,2.37-1.42c.67-.62,1.17-1.4,1.51-2.32l7.2.81c-.45,1.9-1.32,3.56-2.59,4.97-1.27,1.41-2.89,2.51-4.87,3.28-1.97.77-4.23,1.16-6.78,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m322.11,290.89v-6.63h34.82v6.63h-13.49v37.01h-7.84v-37.01h-13.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m370.99,308.72v19.18h-7.71v-43.64h7.54v16.47h.38c.77-1.85,1.96-3.31,3.57-4.38,1.61-1.07,3.67-1.61,6.17-1.61,2.27,0,4.25.48,5.94,1.43,1.69.95,3,2.34,3.93,4.18s1.4,4.07,1.4,6.71v20.84h-7.71v-19.64c0-2.2-.56-3.92-1.69-5.15s-2.71-1.84-4.74-1.84c-1.36,0-2.58.29-3.65.88-1.07.59-1.91,1.44-2.51,2.55-.6,1.11-.91,2.45-.91,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m414.54,328.54c-3.28,0-6.11-.69-8.49-2.06-2.38-1.37-4.21-3.32-5.49-5.84-1.28-2.52-1.92-5.49-1.92-8.92s.64-6.32,1.93-8.87,3.09-4.54,5.4-5.97c2.32-1.43,5.04-2.14,8.16-2.14,2.02,0,3.92.32,5.72.97s3.39,1.64,4.77,2.99,2.48,3.07,3.27,5.15c.8,2.08,1.19,4.56,1.19,7.43v2.37h-26.83v-5.2h19.43c-.01-1.48-.33-2.79-.96-3.95-.62-1.16-1.5-2.07-2.61-2.74-1.12-.67-2.41-1-3.89-1-1.58,0-2.96.38-4.15,1.14s-2.12,1.75-2.78,2.98c-.66,1.23-1,2.58-1.01,4.04v4.54c0,1.9.35,3.53,1.04,4.89.7,1.36,1.67,2.39,2.92,3.11,1.25.72,2.71,1.08,4.39,1.08,1.12,0,2.14-.16,3.05-.48s1.7-.79,2.37-1.42c.67-.62,1.17-1.4,1.51-2.32l7.2.81c-.45,1.9-1.32,3.56-2.59,4.97-1.27,1.41-2.89,2.51-4.87,3.28-1.97.77-4.23,1.16-6.78,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m435.61,327.9v-32.73h7.37v5.56h.38c.68-1.88,1.81-3.34,3.39-4.4,1.58-1.06,3.46-1.59,5.65-1.59s4.09.54,5.61,1.61c1.53,1.07,2.6,2.53,3.23,4.38h.34c.72-1.82,1.95-3.27,3.68-4.36,1.73-1.09,3.77-1.63,6.15-1.63,3.01,0,5.47.95,7.37,2.86,1.9,1.9,2.85,4.68,2.85,8.33v21.97h-7.73v-20.77c0-2.03-.54-3.52-1.62-4.46-1.08-.94-2.4-1.42-3.96-1.42-1.86,0-3.31.58-4.36,1.74-1.04,1.16-1.57,2.66-1.57,4.51v20.41h-7.56v-21.09c0-1.69-.51-3.04-1.52-4.05s-2.34-1.51-3.97-1.51c-1.11,0-2.12.28-3.03.84-.91.56-1.63,1.35-2.17,2.37-.54,1.02-.81,2.2-.81,3.55v19.9h-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m503.97,328.54c-3.28,0-6.11-.69-8.49-2.06-2.38-1.37-4.21-3.32-5.49-5.84-1.28-2.52-1.92-5.49-1.92-8.92s.64-6.32,1.93-8.87,3.09-4.54,5.4-5.97c2.32-1.43,5.04-2.14,8.16-2.14,2.02,0,3.92.32,5.72.97s3.39,1.64,4.77,2.99c1.39,1.35,2.48,3.07,3.27,5.15.79,2.08,1.19,4.56,1.19,7.43v2.37h-26.83v-5.2h19.43c-.01-1.48-.33-2.79-.96-3.95-.63-1.16-1.5-2.07-2.61-2.74-1.12-.67-2.41-1-3.89-1-1.58,0-2.96.38-4.15,1.14s-2.12,1.75-2.78,2.98c-.66,1.23-1,2.58-1.01,4.04v4.54c0,1.9.35,3.53,1.04,4.89.7,1.36,1.67,2.39,2.92,3.11,1.25.72,2.71,1.08,4.39,1.08,1.12,0,2.14-.16,3.05-.48.91-.32,1.7-.79,2.36-1.42.67-.62,1.17-1.4,1.51-2.32l7.2.81c-.46,1.9-1.32,3.56-2.59,4.97-1.27,1.41-2.89,2.51-4.87,3.28-1.97.77-4.23,1.16-6.78,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m550.9,303.82l-7.03.77c-.2-.71-.54-1.38-1.03-2s-1.15-1.13-1.97-1.51c-.82-.38-1.83-.58-3.03-.58-1.61,0-2.95.35-4.04,1.04-1.09.7-1.62,1.6-1.61,2.71-.01.95.34,1.73,1.05,2.32.72.6,1.91,1.09,3.57,1.47l5.58,1.19c3.1.67,5.4,1.73,6.91,3.17,1.51,1.45,2.28,3.35,2.29,5.69-.01,2.06-.61,3.87-1.8,5.44-1.19,1.57-2.83,2.79-4.93,3.68-2.1.88-4.52,1.32-7.24,1.32-4.01,0-7.23-.84-9.67-2.53s-3.9-4.03-4.37-7.04l7.52-.72c.34,1.48,1.07,2.59,2.17,3.35,1.11.75,2.55,1.13,4.33,1.13s3.31-.38,4.42-1.13,1.67-1.68,1.67-2.79c0-.94-.36-1.71-1.08-2.32-.72-.61-1.83-1.08-3.33-1.41l-5.58-1.17c-3.14-.65-5.46-1.76-6.97-3.31-1.51-1.56-2.25-3.53-2.24-5.91-.01-2.02.54-3.77,1.65-5.25,1.11-1.48,2.67-2.63,4.67-3.45,2-.82,4.3-1.22,6.91-1.22,3.83,0,6.86.82,9.07,2.45,2.21,1.63,3.58,3.84,4.1,6.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m120.41,231.38h3.17v17.33c0,1.79-.42,3.39-1.26,4.79-.84,1.4-2.02,2.5-3.55,3.31s-3.32,1.21-5.37,1.21-3.84-.4-5.37-1.21c-1.53-.81-2.71-1.91-3.55-3.31-.84-1.4-1.26-3-1.26-4.79v-17.33h3.17v17.08c0,1.28.28,2.41.84,3.41s1.37,1.77,2.41,2.34c1.04.57,2.29.85,3.75.85s2.71-.28,3.76-.85c1.05-.57,1.85-1.35,2.41-2.34s.84-2.13.84-3.41v-17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m133.09,231.38v26.18h-3.17v-26.18h3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.56,257.92c-1.72,0-3.21-.32-4.45-.95s-2.2-1.5-2.88-2.6c-.67-1.1-1.01-2.36-1.01-3.77,0-1.09.23-2.06.7-2.91.46-.85,1.11-1.64,1.93-2.36.82-.73,1.77-1.46,2.84-2.19l3.78-2.81c.74-.49,1.34-1,1.78-1.56.45-.55.67-1.28.67-2.17,0-.67-.29-1.31-.88-1.93s-1.35-.93-2.29-.93c-.67,0-1.25.17-1.76.5-.51.34-.9.76-1.19,1.28-.29.52-.43,1.05-.43,1.59,0,.61.17,1.23.5,1.86.34.63.77,1.27,1.29,1.92.52.65,1.07,1.32,1.63,2l12.02,14.68h-3.63l-9.92-11.97c-.92-1.11-1.76-2.11-2.51-3.02-.75-.9-1.35-1.79-1.79-2.67-.44-.88-.67-1.83-.67-2.85,0-1.18.26-2.21.79-3.1.52-.89,1.26-1.59,2.21-2.08.95-.5,2.06-.75,3.34-.75s2.44.25,3.39.76c.95.51,1.67,1.18,2.19,2.01s.77,1.73.77,2.7c0,1.25-.31,2.34-.93,3.26-.62.92-1.47,1.78-2.54,2.57l-5.22,3.89c-1.18.87-1.97,1.71-2.39,2.53-.42.82-.63,1.41-.63,1.76,0,.82.21,1.58.64,2.29.43.71,1.03,1.28,1.8,1.71.78.43,1.68.65,2.72.65s1.95-.21,2.89-.63,1.79-1.03,2.55-1.83c.76-.8,1.37-1.76,1.82-2.89s.67-2.39.67-3.8h2.92c0,1.74-.2,3.16-.6,4.26-.4,1.1-.85,1.96-1.36,2.58s-.91,1.09-1.21,1.39c-.1.13-.2.26-.28.38-.08.13-.18.26-.28.38-.84.95-1.91,1.65-3.2,2.12-1.29.46-2.56.7-3.81.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m199.87,231.38h3.17v17.33c0,1.79-.42,3.39-1.26,4.79-.84,1.4-2.02,2.5-3.55,3.31s-3.32,1.21-5.37,1.21-3.84-.4-5.37-1.21-2.71-1.91-3.55-3.31c-.84-1.4-1.26-3-1.26-4.79v-17.33h3.17v17.08c0,1.28.28,2.41.84,3.41s1.37,1.77,2.41,2.34c1.04.57,2.29.85,3.75.85s2.71-.28,3.76-.85c1.05-.57,1.85-1.35,2.41-2.34.56-.99.84-2.13.84-3.41v-17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m210.92,231.38l6.75,10.89h.21l6.75-10.89h3.73l-8.23,13.09,8.23,13.09h-3.73l-6.75-10.69h-.21l-6.75,10.69h-3.73l8.44-13.09-8.44-13.09h3.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m670,270v25.56h25.56v-25.56h-25.56Zm19.17,19.17h-12.78v-12.78h12.78v12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m670,474.44v25.56h25.56v-25.56h-25.56Zm19.17,19.17h-12.78v-12.78h12.78v12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m874.44,270v25.56h25.56v-25.56h-25.56Zm19.17,19.17h-12.78v-12.78h12.78v12.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m874.44,474.44v25.56h25.56v-25.56h-25.56Zm19.17,19.17h-12.78v-12.78h12.78v12.78Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 708.33,
    y1: 282.78,
    x2: 708.33,
    y2: 282.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 727.5,
    y1: 282.78,
    x2: 852.08,
    y2: 282.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 861.67,
    y1: 282.78,
    x2: 861.67,
    y2: 282.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 887.22,
    y1: 308.33,
    x2: 887.22,
    y2: 308.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 887.22,
    y1: 327.5,
    x2: 887.22,
    y2: 452.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 887.22,
    y1: 461.67,
    x2: 887.22,
    y2: 461.67
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 861.67,
    y1: 487.22,
    x2: 861.67,
    y2: 487.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 842.5,
    y1: 487.22,
    x2: 717.92,
    y2: 487.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 708.33,
    y1: 487.22,
    x2: 708.33,
    y2: 487.22
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 682.78,
    y1: 461.67,
    x2: 682.78,
    y2: 461.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 682.78,
    y1: 442.5,
    x2: 682.78,
    y2: 317.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 682.78,
    y1: 308.33,
    x2: 682.78,
    y2: 308.33
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m836.47,362.28h-5.84c-1.54-4.54-4.02-9.41-7.43-14.6-3.41-5.19-6.56-7.99-9.45-8.39-1.59-.2-3.56-.37-5.9-.52-2.34-.15-4.36-.22-6.05-.22h-3.51v83.33c0,1.8.32,3.38.97,4.75.65,1.37,1.92,2.46,3.82,3.26,1.15.45,2.93.91,5.35,1.39,2.42.47,4.48.81,6.18,1.01v5.84h-59.22v-5.84c1.45-.15,3.48-.36,6.1-.64,2.62-.27,4.41-.61,5.35-1.01,1.95-.8,3.24-1.87,3.89-3.22.65-1.35.97-2.95.97-4.79v-84.08h-3.51c-1.69,0-3.71.07-6.05.22-2.34.15-4.31.32-5.9.52-2.89.4-6.04,3.19-9.45,8.39-3.41,5.19-5.89,10.06-7.43,14.6h-5.84v-30.4h102.95v30.4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset3);
export default __webpack_public_path__ + "static/media/Asset 3.6dfb12431b139bfe799eb364df3818c4.svg";
export { ForwardRef as ReactComponent };